// Sonar/client/widgets/RecentAlertsWidget.js
export default {
    name: "RecentAlertsWidget",
    type: "DataWidget",
    description: "Shows a list of the most recent alerts.",
    roles: ["appUser"],
    widget: {
        title: "Recent Alerts",
        size: "large",
        dataProvider: {
            main: {
                rpc: "AlertRpc.getData",
                params: {
                    pageSize: 5,
                    sort: { createdAt: -1 }
                }
            }
        },
        viewMode: "list",
        fields: [
            { name: "title", label: "Alert", isTitle: true },
            { name: "content", label: "Details", isSubtitle: true, render: (val) => val.substring(0, 50) + '...' },
            { name: "createdAt", label: "Date", isMeta: true, render: (val) => new Date(val).toLocaleDateString() }
        ],
        itemAction: {
            type: 'navigate',
            route: '/user/alerts'
        },
        noDataMessage: "You have no recent alerts."
    }
};